"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=LicenseTypes.js.map